import React from "react";
import ToolTip from "components/ToolTip";
import { useOctopusTheme } from "components/Theme";

const styles = require("./ProcessActionErrorIndicator.less");

interface ProcessActionErrorIndicatorProps {
    actionErrors: string[];
}

export const ProcessActionErrorIndicator: React.FC<ProcessActionErrorIndicatorProps> = ({ actionErrors }) => {
    const theme = useOctopusTheme();
    const items = actionErrors.map((x) => <li>{x}</li>);

    return (
        <ToolTip content={<ul>{items}</ul>}>
            <div className={styles.indicatorContainer}>
                <em className="fa fa-exclamation-triangle" style={{ color: theme.danger }} />
            </div>
        </ToolTip>
    );
};
